import type { TimeRange } from '@/admin/components/shared/time-filter'

/** A date as local `YYYY-MM-DD` (the list endpoints' date params). */
export function localDate(d: Date): string {
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * A `TimeFilter` selection as the `created_after` / `created_before` params
 * (local `YYYY-MM-DD`, inclusive) the list endpoints read. Weeks start on
 * Monday, matching the backend date presets; 'all_time' sends nothing.
 */
export function timeRangeToParams(
  range: TimeRange,
  custom?: { from: string; to: string },
): Record<string, string> {
  const now = new Date()
  const p: Record<string, string> = {}
  if (range === 'this_week') {
    const monday = new Date(now)
    monday.setDate(now.getDate() - ((now.getDay() + 6) % 7))
    p.created_after = localDate(monday)
  } else if (range === 'this_month') {
    p.created_after = localDate(new Date(now.getFullYear(), now.getMonth(), 1))
  } else if (range === 'last_month') {
    p.created_after = localDate(new Date(now.getFullYear(), now.getMonth() - 1, 1))
    p.created_before = localDate(new Date(now.getFullYear(), now.getMonth(), 0))
  } else if (range === 'custom' && custom) {
    p.created_after = custom.from
    p.created_before = custom.to
  }
  return p
}
